/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Basic_AiInputs */

const en_landing_pricing_feature_basic_ai = /** @type {(inputs: Landing_Pricing_Feature_Basic_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-generated bilingual intro`)
};

const zh_landing_pricing_feature_basic_ai = /** @type {(inputs: Landing_Pricing_Feature_Basic_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 生成双语简介`)
};

/**
* | output |
* | --- |
* | "AI-generated bilingual intro" |
*
* @param {Landing_Pricing_Feature_Basic_AiInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_basic_ai = /** @type {((inputs?: Landing_Pricing_Feature_Basic_AiInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Basic_AiInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_basic_ai(inputs)
	return zh_landing_pricing_feature_basic_ai(inputs)
});
export { landing_pricing_feature_basic_ai as "landing.pricing.feature_basic_ai" }